import Separator from 'components/common/separator';
import Text from 'components/elements/text';
import { CardSection } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import ActivityRescheduleGuestTable from './guest-table';
import NewActivityTables from './table';
import ActivityRescheduleAddOnsTable from './table/add-ons-table';
import { ScheduleCardHeader, ScheduleCardHeaderLeft } from '../../style';

export default function ActivityRescheduleItemCard({
  parentIndex,
}: {
  parentIndex: number;
}) {
  const { t } = useTranslation();

  return (
    <CardSection>
      <ScheduleCardHeader>
        <ScheduleCardHeaderLeft>
          <Text variant="HeadingXSmall">
            {t('common:other_sale_detail')} {parentIndex + 1}
          </Text>
        </ScheduleCardHeaderLeft>
      </ScheduleCardHeader>
      <Separator gap={16} />

      <ActivityRescheduleGuestTable parentIndex={parentIndex} />
      <Separator gap={8} />

      <NewActivityTables parentIndex={parentIndex} />

      <Separator gap={8} />
      <ActivityRescheduleAddOnsTable parentIndex={parentIndex} />
    </CardSection>
  );
}
